/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import '../common/customer_management';
import '../common/order_tickets';
import '../common/payment_sounds';
import '../common/payment_types';
import '../common/quick_amounts';
import '../common/security';
import '../common/signature';
import '../common/store_and_forward';
import '../common/tile';
import '../common/tipping';
import '../common/buyer_facing_display';
import '../addons/cash_management';
import '../addons/open_tickets';
import '../addons/gift_cards';
import '../addons/invoices';
import '../addons/loyalty';
import '../addons/text_message_marketing';
import '../addons/messages';
import '../addons/buyer_subscriptions';
import '../addons/team_management';
import '../addons/estimates';
import '../addons/staff';
import '../addons/online_checkout';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "apos": {
                            "nested": {
                              "APOSSettings": {
                                "fields": {
                                  "customerManagement": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.CustomerManagement",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "orderTickets": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.OrderTickets",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "paymentSounds": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentSounds",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "paymentTypes": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.PaymentTypes",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "quickAmount": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.QuickAmounts",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "security": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Security",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "signature": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Signature",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "storeAndForward": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.StoreAndForward",
                                    "id": 8,
                                    "rule": "optional"
                                  },
                                  "tile": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tile",
                                    "id": 9,
                                    "rule": "optional"
                                  },
                                  "tipping": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping",
                                    "id": 10,
                                    "rule": "optional"
                                  },
                                  "addonsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.apos.APOSSettings.AddonsSettings",
                                    "id": 11,
                                    "rule": "optional"
                                  },
                                  "buyerFacingDisplay": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.BuyerFacingDisplay",
                                    "id": 12,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "AddonsSettings": {
                                    "fields": {
                                      "cashManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.CashManagement",
                                        "id": 1,
                                        "rule": "optional"
                                      },
                                      "openTickets": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OpenTickets",
                                        "id": 2,
                                        "rule": "optional"
                                      },
                                      "giftCards": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.GiftCards",
                                        "id": 3,
                                        "rule": "optional"
                                      },
                                      "invoices": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Invoices",
                                        "id": 4,
                                        "rule": "optional"
                                      },
                                      "loyalty": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Loyalty",
                                        "id": 5,
                                        "rule": "optional"
                                      },
                                      "textMessageMarketing": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TextMessageMarketing",
                                        "id": 6,
                                        "rule": "optional"
                                      },
                                      "messages": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Messages",
                                        "id": 7,
                                        "rule": "optional"
                                      },
                                      "buyerSubscriptions": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.BuyerSubscriptions",
                                        "id": 8,
                                        "rule": "optional"
                                      },
                                      "teamManagement": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.TeamManagement",
                                        "id": 9,
                                        "rule": "optional"
                                      },
                                      "estimates": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Estimates",
                                        "id": 10,
                                        "rule": "optional"
                                      },
                                      "staff": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.Staff",
                                        "id": 11,
                                        "rule": "optional"
                                      },
                                      "onlineCheckout": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.addons.OnlineCheckout",
                                        "id": 12,
                                        "rule": "optional"
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.apos?.nested?.APOSSettings && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.apos?.nested?.APOSSettings?.nested?.AddonsSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE APOSSettings @ squareup/devicesettings/profiles/v2/model/settings/apos/apos_settings.proto at 41:1
 */
export const APOSSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.apos.APOSSettings');
fixType(APOSSettings);
Builder.createAndAttachToType(APOSSettings);
/**
 * SOURCE AddonsSettings @ squareup/devicesettings/profiles/v2/model/settings/apos/apos_settings.proto at 55:3
 */
APOSSettings.AddonsSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.apos.APOSSettings.AddonsSettings');
fixType(APOSSettings.AddonsSettings);
Builder.createAndAttachToType(APOSSettings.AddonsSettings);